var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('entity-tooltip');
import { breakpoints, theme } from '@shapeable/theme';
import { EntityLinkValue } from './entity-link-value';
import { EntityValue } from './entity-value';
import { ContentNode } from './content-node';
import { coalesce } from '../../utils/coalesce';
export var EntityTooltipDefaultProps = {
  showDescription: true
}; // -------- Child Component Props -------->
// -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: ", ";\n    padding: ", ";\n    a {\n      text-decoration: none;\n      color: ", " !important;\n\n      &:hover {\n        color: ", " !important;\n      }\n    }\n  "], ["\n    font-family: ", ";\n    padding: ", ";\n    a {\n      text-decoration: none;\n      color: ", " !important;\n\n      &:hover {\n        color: ", " !important;\n      }\n    }\n  "])), theme.FONT('sans'), theme.UNIT(4), theme.COLOR('dark'), theme.COLOR('primary'))
});
var DescriptionStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    text-decoration: none;\n    font-size: ", ";\n    line-height: 1.2em;\n    margin-top: ", ";\n    color: ", ";\n  "], ["\n    text-decoration: none;\n    font-size: ", ";\n    line-height: 1.2em;\n    margin-top: ", ";\n    color: ", ";\n  "])), theme.FONT_SIZE(13), theme.UNIT(3), theme.COLOR('text'))
});
var LinkStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ValueStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Description: styled(ContentNode)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Link: styled(EntityLinkValue)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Value: styled(EntityValue)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles)
};
/**
 * Displays the `OpenGraphInfo` fields of an `Entity` in a layout appropriate for tooltips, such as those used
 * in MapBox.
 */

export var EntityTooltip = function EntityTooltip(props) {
  var className = props.className,
      entity = props.entity,
      children = props.children,
      showDescription = props.showDescription,
      onLinkClick = props.onLinkClick,
      onSelect = props.onSelect,
      footer = props.footer,
      valueProps = __rest(props, ["className", "entity", "children", "showDescription", "onLinkClick", "onSelect", "footer"]);

  var description = coalesce(entity, ['description', 'openGraph.description']);
  var hasDescription = showDescription && description && description.text;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, entity.path ? React.createElement(My.Link, __assign({}, valueProps, {
    onClick: onLinkClick || onSelect,
    entity: entity
  })) : React.createElement(My.Value, __assign({}, valueProps, {
    entity: entity
  })), children, hasDescription && React.createElement(My.Description, {
    entity: description
  }), footer);
};
EntityTooltip.defaultProps = EntityTooltipDefaultProps;
EntityTooltip.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;